import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

import css from './PurchaseConfirmAlert.module.scss';

interface Props {
  className?: string;
  labelType: string;
  termsUrl: string;
  lawUrl: string;
}

const PurchaseConfirmAlert = ({
  className,
  intl,
  labelType,
  termsUrl,
  lawUrl,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.PurchaseConfirmAlert, className);

  return (
    <div className={classes}>
      <p className={`${css.PurchaseConfirmAlert__Paragraph} ${css.isBold}`}>
        {intl.formatMessage({
          id: `purchases.purchaseConfirmAlert.message1.${labelType}`,
        })}
        <br />
        <span className={css.PurchaseConfirmAlert__Em}>
          {intl.formatMessage({
            id: `purchases.purchaseConfirmAlert.message2.${labelType}`,
          })}
        </span>
      </p>
      <p className={css.PurchaseConfirmAlert__Paragraph}>
        <FormattedMessage
          id={`purchases.purchaseConfirmAlert.message3.${labelType}`}
          values={{
            terms: (
              <Link href={termsUrl} prefetch={false}>
                <a
                  className={css.PurchaseConfirmAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({
                    id: 'purchases.purchaseConfirmAlert.termOfUse',
                  })}
                </a>
              </Link>
            ),
            law: (
              <Link href={lawUrl} prefetch={false}>
                <a
                  className={css.PurchaseConfirmAlert__Link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {intl.formatMessage({
                    id:
                      'purchases.purchaseConfirmAlert.specifiedCommercialTransactionsLaw',
                  })}
                </a>
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default injectIntl(PurchaseConfirmAlert);
